import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';
import { AuthenticationService } from '../authentication/authentication.service';

// Global counter for API requests (shared across all interceptor instances)
let apiRequestCount = 0;

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const authenticationService = inject(AuthenticationService);

  // Increment request count and show loader
  ++apiRequestCount;
  loaderService.show();

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => handleAuthError(err, authenticationService)),
    finalize(() => {
      // Decrement request count and hide loader if no more requests
      --apiRequestCount;
      if (apiRequestCount === 0) {
        loaderService.hide();
      }
    })
  );
};

// Helper function to handle authentication errors
function handleAuthError(
  err: HttpErrorResponse,
  authenticationService: AuthenticationService
): Observable<any> {
  if (err.status === 401 || err.status === 403) {
    authenticationService.logout();
    // Return the error message instead of rethrowing
    return of(err.message);
  }
  return throwError(() => err);
}
